<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <report-control></report-control>
      <report-view></report-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ReportControl from "@/components/reports/reportControl";
import ReportView from "@/components/reports/reportView";

export default {
  data() {
    return {
      fid: Number(this.$route.query.fid)
    };
  },
  methods: {},
  mounted() {
    if (!!this.fid) {
      this.selectedReport = this.fid;
    }
  },
  computed: {
    selectedReport: Store.getSet({ store: "reports", prop: "selectedReport" })
  },
  components: {
    ReportControl,
    ReportView
  }
};
</script>

<style scoped>
</style>
